import React from "react";
import { NumericTextBox, Checkbox } from "@progress/kendo-react-inputs";
import styles from "./CtoSweep.module.scss";

export const AllocationCell = (props) => (
  <td className="right-align-full numeric-input-padding">
    <NumericTextBox
      format={"n2"}
      className="mt-auto w-75"
      value={props.dataItem.maxAllocateAmount}
      onChange={(e) => {
        if (props.onChange) {
          const value =
            e.value > props.dataItem.originalMaxAllocateAmount
              ? props.dataItem.originalMaxAllocateAmount
              : e.value;

          props.onChange({
            dataItem: props.dataItem,
            field: props.field,
            value: value,
          });
        }
      }}
      spinners={false}
      disabled={!props.dataItem.add}
      style={{ width: 80 }}
    />
  </td>
);

export const SelectCell = ({ dataItem, field, onChange, ...props }) => (
  <td className="text-center align-middle">
    <Checkbox
      checked={!!dataItem.add}
      onChange={(e) =>
        onChange({
          dataItem,
          field,
          value: e.value,
        })
      }
      {...props}
    />
  </td>
);

export const MatterListItem = ({ matter, isSelected, onClick }) => (
  <div
    className={`${styles.matterListItem} ${isSelected ? styles.selected : ""}`}
    onClick={onClick}
  >
    <div className={styles.title}>{matter.matterRef || matter.matterId}</div>
    <div className={styles.details}>
      {matter.matterDetails || "Matter Details Not Available"}
    </div>
  </div>
);
